import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { ResponsiveBar } from "@nivo/bar";
import { format } from "date-fns";

import { data, indicatorsMap02 } from "../dataSet/dataSet";
import Paperplane from "../../../Loading/Paperplane/Paperplane";

import * as APIDashboard from "../../../../services/nps/functions";

import { ReactComponent as HamburgerIcon } from "../../../../build/images/icons/hamburger.svg";
import { ReactComponent as EmptyState } from "../../../../build/images/emptystatemanagerhorizontal.svg";

import "./notes.css";

export default function Notes() {
  const filtersDashboard = useSelector((state) => state.npsfilters);

  const [dataGeneral, setDataGeneral] = useState([]);
  const [dispareFilter, setDispareFilter] = useState(false);
  const [loading, setLoading] = useState(false);

  const formattedData = data.reduce((acc, current, index) => {
    const gender = index % 2 === 0 ? "Male" : "Female";
    const newData = { ...current, id: index, gender };
    acc.push(newData);
    return acc;
  }, []);

  async function getIndicatorsNotes() {
    setLoading(true);
    const response = await APIDashboard.indicatorsNotes(
      format(new Date(filtersDashboard.datestart), "yyyy-MM-dd"),
      format(new Date(filtersDashboard.dateend), "yyyy-MM-dd"),
      filtersDashboard.units.map((option) => option.id).join(),
      filtersDashboard.business.map((option) => option.id).join(),
      filtersDashboard.questionsNPS.map((option) => option.id).join(),
      filtersDashboard.questionsCSAT.map((option) => option.id).join(),
      filtersDashboard.channels.map((option) => option.id).join(),
    );

    if (response.status === 200) {
      // { note: 0, male: 100, female: 500 }
      const data = response.data;
      let newData = data.map((datum) => {
        let formatted = {
          note: datum.answer,
        };

        if (datum.gender_client === "M") {
          formatted.male = Number(datum.qtde);
        } else {
          formatted.female = Number(datum.qtde);
        }

        return formatted;
      });

      setDataGeneral(formatarArray(newData));
      setDispareFilter(true);
    } else {
      console.log(
        "Falha, não foi possível carregar as informações!",
        "Verifique sua conexão e tente novamente mais tarde.",
      );
    }
    setLoading(false);
  }

  function formatarArray(array) {
    const result = [];

    array.forEach((obj) => {
      const existingObj = result.find((item) => item.note === obj.note);

      if (existingObj) {
        if ("female" in obj) {
          existingObj.female = obj.female;
        }
        if ("male" in obj) {
          existingObj.male = obj.male;
        }
      } else {
        const newObj = { note: obj.note, female: 0, male: 0 };
        if ("female" in obj) {
          newObj.female = obj.female;
        }
        if ("male" in obj) {
          newObj.male = obj.male;
        }
        result.push(newObj);
      }
    });

    return result;
  }

  useEffect(() => {
    getIndicatorsNotes();
  }, []);

  useEffect(() => {
    if (filtersDashboard.active && dispareFilter) {
      getIndicatorsNotes();
    }
  }, [filtersDashboard]);

  return (
    <div className="notes">
      <header className="notes__header">
        <div className="cards-headers">
          <h4>Notas</h4>
        </div>

        {/* <button className="notes__hamburger-icon">
          <HamburgerIcon />
        </button> */}
      </header>

      <div className="notes__graphic">
        {loading ? (
          <Paperplane width={"50%"} height={"100%"} />
        ) : dataGeneral.length ? (
          <ResponsiveBar
            data={dataGeneral}
            keys={["male", "female"]}
            indexBy="note"
            layout="vertical"
            valueScale={{ type: "linear" }}
            indexScale={{ type: "band", round: true }}
            margin={{ top: 50, right: 0, bottom: 30, left: 30 }}
            padding={0.7}
            colors={["#455cc7", "#d81b60"]}
            axisLeft={{
              tickSize: 0,
              tickPadding: 5,
              tickRotation: 0,
              legend: "",
              legendPosition: "middle",
              legendOffset: -60,
              style: {
                color: "var(--Shades-Preto-Inativo, rgba(0, 0, 0, 0.38))",
                fontFeatureSettings: "'clig' off, 'liga' off",
                fontFamily: "Inter",
                fontSize: 12,
                fontStyle: "normal",
                fontWeight: 400,
                lineHeight: "20px",
              },
            }}
            axisBottom={{
              tickSize: 0,
              tickPadding: 5,
              tickRotation: 0,
              style: {
                color: "var(--Shades-Preto-Inativo, rgba(0, 0, 0, 0.38))",
                fontFeatureSettings: "'clig' off, 'liga' off",
                fontFamily: "Inter",
                fontSize: 12,
                fontStyle: "normal",
                fontWeight: 400,
                lineHeight: "20px",
              },
            }}
            enableGridY={true}
            borderRadius={1.5}
            borderWidth={2}
            barWidth={16}
            // enableLabel={false}
            // labelSkipWidth={12}
            labelSkipHeight={12}
            labelTextColor="#FFF"
            tooltip={({ id, value, color, indexValue }) => {
              let keyInPortuguese = "";
              if (id === "male") {
                keyInPortuguese = "Masculino";
              } else if (id === "female") {
                keyInPortuguese = "Feminino";
              }
              return (
                <div
                  style={{
                    padding: 5,
                    color: "#222222",
                    background: "#ffffff",
                    borderRadius: 2,
                    display: "flex",
                    alignItems: "center",
                    gap: 10,
                    boxShadow: "1px 1px 2px 0px rgba(0,0,0,0.35)",
                  }}
                >
                  <div
                    style={{ width: 14, height: 14, backgroundColor: color }}
                  ></div>
                  <div>
                    {keyInPortuguese} - {indexValue}: <strong>{value}</strong>
                  </div>
                </div>
              );
            }}
          />
        ) : (
          <div className="card-table__area-empty">
            <EmptyState />
          </div>
        )}
      </div>

      <div className="graphic-indicators">
        {Object.keys(indicatorsMap02).map((key) => {
          const { className, text } = indicatorsMap02[key];
          return (
            <span key={key} className={className}>
              <div className={`${className}__color`} />
              <h6 className={`${className}__h6`}>{text}</h6>
            </span>
          );
        })}
      </div>
    </div>
  );
}
